import React from 'react';

import { shallowEqual, useSelector } from 'react-redux';
import PurchaseTransactions from './Payables';

export default function PayablePage() {
  const { authorizedUser } = useSelector(
    ({ auth }) => ({
      authorizedUser: auth.user,
    }),
    shallowEqual
  );
  return (
    <div>
      <PurchaseTransactions authorizedUser={authorizedUser} />
    </div>
  );
}
